<script setup lang="ts">
import { IconProps } from '@/runtime/types/IconTypes';
import { computed } from 'vue';

const props = defineProps<IconProps>();

if (!props.name) {
  throw new Error('Icon name prop is required');
}

const icons = import.meta.glob('../../../assets/icons/*.svg', {
  eager: true,
  query: 'raw',
  import: 'default'
}) as Record<string, string>;

const svgContent = computed((): string | null => {
  const key = `../../../assets/icons/${props.name}.svg`;
  const raw = icons[key];

  if (!raw) {
    console.warn(`Icon not found: ${props.name}.svg`);
    return null;
  }

  return raw.replace('<svg', '<svg width="1em" height="1em"');
});
</script>

<template>
  <div
    v-if="svgContent"
    class="e-icon-wrapper"
  >
    <span
      class="e-icon"
      role="img"
      :aria-label="props.name"
      v-html="svgContent"
    />
  </div>
  <div
    v-else
    class="hidden"
    aria-hidden="true"
  />
</template>
